import { Action } from '@ngrx/store';
import { ISearchUser } from '@account-users/user/models/ISearchUser';
import {
  UsersLicensPermissions,
  IBulkEdit,
} from '@account-users/account/models/LicensePermissionList';

export enum UserActionTypes {
  LOAD_USERS = '[Users] Load All Users',
  LOAD_ACCOUNT_USERS = '[Users] Load All Account Users',
  LOAD_USERS_SUCCESS = '[Users] Load All Users Success',
  LOAD_USERS_FAILED = '[Users] Load All Users Failed',

  RESET_ACCOUNT_USERS = '[Users] RESET All Account Users',
  SELECT_USER = '[Users] Select Account User',
  SELECT_ALL_USERS = '[Users] Select All Account Users',
  RESET_SELECTED_USERS = '[Users] Reset Selected Account Users',

  SET_BULK_EDIT = '[Users] Set Bulk Edit Account Users & Permissions',
  RESET_BULK_EDIT = '[Users] Reset Bulk Edit Account Users & Permissions',

  BULK_EDIT_ACCOUNT_USER_PERMISSIONS = '[Users] Bulk Edit Account User Permissions',
  BULK_EDIT_ACCOUNT_USER_PERMISSIONS_SUCCESS = '[Users] Bulk Edit Account User Permissions Success',
  BULK_EDIT_ACCOUNT_USER_PERMISSIONS_FAILURE = '[Users] Bulk Edit Account User Permissions Failure',

  DOWNLOAD_BULK_PERMISSION_CSV = '[Users] Download Bulk Account User Permissions CSV',
  DOWNLOAD_BULK_PERMISSION_CSV_SUCCESS = '[Users] Download Bulk Account User Permissions CSV Success',
  DOWNLOAD_BULK_PERMISSION_CSV_FAILURE = '[Users] Download Bulk Account User Permissions CSV Failure',

  DOWNLOAD_ACCOUNT_USER_CSV = '[Users] Download Account User CSV',
  DOWNLOAD_ACCOUNT_USER_CSV_SUCCESS = '[Users] Download Account User CSV Success',
  DOWNLOAD_ACCOUNT_USER_CSV_FAILURE = '[Users] Download Account User CSV Failure',
}

export class LoadUsers implements Action {
  readonly type = UserActionTypes.LOAD_USERS;
  constructor(public payload: { query: string; roles: string[] }) {}
}

export class LoadAccountUsers implements Action {
  readonly type = UserActionTypes.LOAD_ACCOUNT_USERS;
  constructor(
    public payload: {
      query: string;
      roles: string[];
      accountCategories: string[];
      permissions: string[];
    },
  ) {}
}

export class ResetAccountUsers implements Action {
  readonly type = UserActionTypes.RESET_ACCOUNT_USERS;
}

export class LoadUsersSuccess implements Action {
  readonly type = UserActionTypes.LOAD_USERS_SUCCESS;
  constructor(public payload: ISearchUser[]) {}
}

export class LoadUsersFailed implements Action {
  readonly type = UserActionTypes.LOAD_USERS_FAILED;
}

export class SetBulkEdit implements Action {
  readonly type = UserActionTypes.SET_BULK_EDIT;
  constructor(
    public payload: {
      users: ISearchUser[];
      licenses: UsersLicensPermissions[];
    },
  ) {}
}

export class BulkEditAccountUserPermissions implements Action {
  readonly type = UserActionTypes.BULK_EDIT_ACCOUNT_USER_PERMISSIONS;
}

export class BulkEditAccountUserPermissionsSuccess implements Action {
  readonly type = UserActionTypes.BULK_EDIT_ACCOUNT_USER_PERMISSIONS_SUCCESS;
  constructor(public payload: { success: IBulkEdit[]; failed: IBulkEdit[] }) {}
}

export class BulkEditAccountUserPermissionsFailure implements Action {
  readonly type = UserActionTypes.BULK_EDIT_ACCOUNT_USER_PERMISSIONS_FAILURE;
}

export class DownloadPermissionRemoveCSV implements Action {
  readonly type = UserActionTypes.DOWNLOAD_BULK_PERMISSION_CSV;
}

export class DownloadPermissionRemoveCSVSuccess implements Action {
  readonly type = UserActionTypes.DOWNLOAD_BULK_PERMISSION_CSV_SUCCESS;
}

export class DownloadPermissionRemoveCSVFailure implements Action {
  readonly type = UserActionTypes.DOWNLOAD_BULK_PERMISSION_CSV_FAILURE;
}

export class DownloadAccountUserCSV implements Action {
  readonly type = UserActionTypes.DOWNLOAD_ACCOUNT_USER_CSV;
  constructor(public payload: boolean) {}
}

export class DownloadAccountUserCSVSuccess implements Action {
  readonly type = UserActionTypes.DOWNLOAD_ACCOUNT_USER_CSV_SUCCESS;
}

export class DownloadAccountUserCSVFailure implements Action {
  readonly type = UserActionTypes.DOWNLOAD_ACCOUNT_USER_CSV_FAILURE;
}

export class ResetBulkEdit implements Action {
  readonly type = UserActionTypes.RESET_BULK_EDIT;
}

export class SelectUser implements Action {
  readonly type = UserActionTypes.SELECT_USER;
  constructor(public payload: { user: ISearchUser }) {}
}

export class SelectAllUsers implements Action {
  readonly type = UserActionTypes.SELECT_ALL_USERS;
  constructor(public payload: { users: ISearchUser[] }) {}
}

export class ResetSelectedUsers implements Action {
  readonly type = UserActionTypes.RESET_SELECTED_USERS;
}

export type UserActions =
  | LoadUsers
  | LoadAccountUsers
  | LoadUsersSuccess
  | ResetAccountUsers
  | LoadUsersFailed
  | SetBulkEdit
  | BulkEditAccountUserPermissions
  | BulkEditAccountUserPermissionsSuccess
  | BulkEditAccountUserPermissionsFailure
  | SelectUser
  | SelectAllUsers
  | ResetSelectedUsers
  | ResetBulkEdit
  | DownloadPermissionRemoveCSV
  | DownloadPermissionRemoveCSVSuccess
  | DownloadPermissionRemoveCSVFailure
  | DownloadAccountUserCSV
  | DownloadAccountUserCSVSuccess
  | DownloadAccountUserCSVFailure;
